/* Godspeed rebuild. Vanilla. Deferred. No dependencies. */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function qs(sel, root) {
    return (root || document).querySelector(sel);
  }

  function qsa(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  function setText(el, text) {
    if (el && el.textContent !== text) el.textContent = text;
  }

  function show(el, on) {
    if (el) el.hidden = !on;
  }

  /* ---------- Cart. Drawer, header count, one add call, gift rules. ---------- */
  var Cart = (function () {
    var root = null;
    var giftsHandle = '';
    var lastFocus = null;
    var busy = false;
    var closeTimer = null;

    function routes() {
      return window.routes || { cart_url: '/cart', cart_add_url: '/cart/add', cart_update_url: '/cart/update' };
    }

    function drawer() {
      if (!root) root = qs('[data-gs-drawer]');
      return root;
    }

    function sectionId() {
      var d = drawer();
      return (d && d.getAttribute('data-section')) || 'gs-cart-drawer';
    }

    function request(path, body) {
      return fetch(path, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body),
      }).then(function (r) {
        return r.json().then(function (json) {
          if (!r.ok) throw json;
          return json;
        });
      });
    }

    function fetchCart() {
      return fetch(routes().cart_url + '.js', { headers: { Accept: 'application/json' } }).then(function (r) {
        return r.json();
      });
    }

    function isGift(item) {
      return !!giftsHandle && item.handle === giftsHandle;
    }

    function isSub(item) {
      return !isGift(item) && !!item.selling_plan_allocation;
    }

    // The badge counts drink lines only.
    function drinkCount(cart) {
      return cart.items.reduce(function (n, it) {
        return n + (isGift(it) ? 0 : it.quantity);
      }, 0);
    }

    function setCount(cart) {
      var n = String(drinkCount(cart));
      qsa('[data-gs-cart-count]').forEach(function (el) {
        setText(el, n);
      });
    }

    // Gift rules. A gift line exists only beside a subscription drink line, and only one of each.
    function fixes(cart) {
      var hasSub = cart.items.some(isSub);
      var updates = {};
      var n = 0;
      cart.items.forEach(function (it) {
        if (!isGift(it)) return;
        if (!hasSub) {
          updates[it.key] = 0;
          n += 1;
        } else if (it.quantity !== 1) {
          updates[it.key] = 1;
          n += 1;
        }
      });
      return n ? updates : null;
    }

    function render(html) {
      var d = drawer();
      if (!d || !html) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = qs('[data-gs-drawer]', doc);
      if (fresh) d.innerHTML = fresh.innerHTML;
    }

    // The digital gift rows (display only, not cart lines) show only beside a subscription drink line.
    function setDigital(cart) {
      var d = drawer();
      if (!d) return;
      var hasSub = cart.items.some(isSub);
      qsa('[data-gs-digital-gifts]', d).forEach(function (el) {
        el.hidden = !hasSub;
      });
    }

    function settle(cart) {
      var upd = fixes(cart);
      if (upd) return update(upd);
      setCount(cart);
      setDigital(cart);
      return cart;
    }

    function applyResponse(json) {
      var id = sectionId();
      if (json.sections && json.sections[id]) render(json.sections[id]);
      if (json.items) return settle(json);
      return fetchCart().then(settle);
    }

    function update(updates) {
      return request(routes().cart_update_url + '.js', { updates: updates, sections: sectionId() }).then(applyResponse);
    }

    function add(items) {
      return request(routes().cart_add_url + '.js', { items: items, sections: sectionId() }).then(applyResponse);
    }

    function refresh() {
      var id = sectionId();
      return fetch(window.location.pathname + '?sections=' + id, { headers: { Accept: 'application/json' } })
        .then(function (r) {
          return r.json();
        })
        .then(function (sections) {
          render(sections[id]);
          return fetchCart();
        })
        .then(settle)
        .catch(function () {});
    }

    function open() {
      var d = drawer();
      if (!d) {
        window.location.href = routes().cart_url;
        return;
      }
      if (closeTimer) window.clearTimeout(closeTimer);
      lastFocus = document.activeElement;
      d.hidden = false;
      d.removeAttribute('inert');
      document.body.classList.add('gs-drawer-open');
      window.requestAnimationFrame(function () {
        d.classList.add('is-open');
        var panel = qs('.gs-drawer__panel', d);
        if (panel) panel.focus();
      });
    }

    function close() {
      var d = drawer();
      if (!d || !d.classList.contains('is-open')) return;
      d.classList.remove('is-open');
      document.body.classList.remove('gs-drawer-open');
      closeTimer = window.setTimeout(
        function () {
          d.hidden = true;
        },
        reduceMotion ? 0 : 260
      );
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    // A drawer row can stand for several cart lines (Shopify splits a drink line when the gift discount uses
    // part of its quantity). The new total goes on the first key, every other key of the group goes to zero,
    // all in one update call. The re-render groups whatever the response holds.
    function change(line, qty) {
      var d = drawer();
      if (busy || !d) return;
      busy = true;
      d.classList.add('is-busy');
      var kind = line.getAttribute('data-kind');
      var keys = (line.getAttribute('data-gs-keys') || line.getAttribute('data-key') || '')
        .split(',')
        .filter(Boolean);
      var updates = {};
      keys.forEach(function (k, i) {
        updates[k] = i === 0 ? Math.max(0, qty) : 0;
      });
      // Removing the last subscription drink row removes both gift lines in the same call.
      if (kind === 'sub' && qty <= 0) {
        var otherSubs = qsa('[data-gs-line][data-kind="sub"]', d).filter(function (l) {
          return l !== line;
        });
        if (!otherSubs.length) {
          qsa('[data-gs-line][data-kind="gift"]', d).forEach(function (g) {
            updates[g.getAttribute('data-key')] = 0;
          });
        }
      }
      update(updates)
        .catch(function () {})
        .then(function () {
          busy = false;
          d.classList.remove('is-busy');
        });
    }

    function bind() {
      var d = drawer();
      if (d) giftsHandle = d.getAttribute('data-gifts-handle') || '';

      document.addEventListener('click', function (e) {
        var opener = e.target.closest('[data-gs-cart-open]');
        if (opener) {
          e.preventDefault();
          refresh();
          open();
          return;
        }
        if (!d || !d.contains(e.target)) return;
        if (e.target.closest('[data-gs-drawer-close]')) {
          close();
          return;
        }
        var line = e.target.closest('[data-gs-line]');
        if (!line) return;
        var qty = Number(line.getAttribute('data-qty')) || 0;
        var next = null;
        if (e.target.closest('[data-gs-line-inc]')) next = qty + 1;
        else if (e.target.closest('[data-gs-line-dec]')) next = Math.max(1, qty - 1);
        else if (e.target.closest('[data-gs-line-remove]')) next = 0;
        if (next === null || next === qty) return;
        change(line, next);
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && d && d.classList.contains('is-open')) close();
      });

      window.addEventListener('pageshow', function (e) {
        if (e.persisted) refresh();
      });

      // Anything already in the cart that breaks the gift rules is fixed on load.
      if (d) fetchCart().then(settle).catch(function () {});
    }

    return { bind: bind, add: add, open: open, close: close, refresh: refresh };
  })();

  /* ---------- PDP buy box ---------- */
  function initPdp() {
    var root = qs('[data-gs-pdp]');
    if (!root) return;

    var stateEl = qs('[data-gs-pdp-state]', root);
    if (!stateEl) return;
    var cfg;
    try {
      cfg = JSON.parse(stateEl.textContent);
    } catch (e) {
      return;
    }

    var form = document.getElementById(cfg.formId);
    if (!form) return;

    var planKeys = Object.keys(cfg.plans || {});
    var hasSub = cfg.hasSub && planKeys.length > 0;

    var el = {
      inputId: qs('[data-gs-input-id]', form),
      inputQty: qs('[data-gs-input-qty]', form),
      inputPlan: qs('[data-gs-input-plan]', form),
      button: qs('[data-gs-buy-button]', form),
      ctaLabel: qs('[data-gs-cta-label]', form),
      error: qs('[data-gs-buy-error]', root),
      flavorName: qs('[data-gs-flavor-name]', root),
      subCard: qs('[data-gs-mode-card="sub"]', root),
      onceCard: qs('[data-gs-mode-card="once"]', root),
      limited: qs('[data-gs-limited]', root),
      subFlag: qs('[data-gs-sub-flag]', root),
      subWas: qs('[data-gs-sub-was]', root),
      subNow: qs('[data-gs-sub-now]', root),
      subQtyLabel: qs('[data-gs-sub-qty-label]', root),
      delivery: qs('[data-gs-delivery]', root),
      subGiftsLine: qs('[data-gs-sub-gifts-line]', root),
      oncePrice: qs('[data-gs-once-price]', root),
      slides: qsa('[data-gs-slide]', root),
      thumbs: qsa('[data-gs-thumb]', root),
      stage: qs('[data-gs-stage]', root),
      thumbStrip: qs('[data-gs-thumbs]', root),
      prev: qs('[data-gs-gallery-prev]', root),
      next: qs('[data-gs-gallery-next]', root),
      tiles: qsa('[data-gs-tile]', root),
      subTiles: qsa('[data-gs-sub-tile]', root),
      sticky: qs('[data-gs-sticky]'),
    };

    var state = {
      flavor: cfg.startFlavor === 'straw' && cfg.flavors.straw ? 'straw' : 'lemon',
      mode: 'once',
      qty: 1,
      subQty: cfg.subDefault || Number(planKeys[0]) || 1,
      slide: 0,
    };
    if (hasSub && state.flavor === 'lemon') state.mode = 'sub';

    function money(cents) {
      var whole = cents % 100 === 0;
      var n = whole ? String(cents / 100) : (cents / 100).toFixed(2);
      return (cfg.currencySymbol || '$') + n.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }

    function money2(cents) {
      return (cfg.currencySymbol || '$') + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }

    function oncePrice(flavor, qty) {
      var unit = cfg.flavors[flavor].price;
      var off = cfg.bundleOff[String(qty)] || 0;
      return unit * qty - off;
    }

    function plan() {
      return cfg.plans[String(state.subQty)];
    }

    // Mobile gallery. Under 750px the stage is a swipe track and the thumb strip follows it.
    var mobileMq = window.matchMedia ? window.matchMedia('(max-width: 749px)') : null;
    function isMobileGallery() {
      return !!(mobileMq && mobileMq.matches && el.stage);
    }
    var ignoreScrollUntil = 0;
    var slideFromSwipe = false;

    function scrollStageTo(index) {
      var stage = el.stage;
      if (!stage) return;
      var target = index * stage.clientWidth;
      if (Math.abs(stage.scrollLeft - target) < 2) return;
      ignoreScrollUntil = Date.now() + 400;
      if (typeof stage.scrollTo === 'function') stage.scrollTo({ left: target, behavior: reduceMotion ? 'auto' : 'smooth' });
      else stage.scrollLeft = target;
    }

    // Keeps the active thumb inside the strip. Only the strip scrolls, never the page.
    function scrollThumbIntoView(thumb) {
      var strip = el.thumbStrip;
      if (!strip || !thumb) return;
      var left = thumb.offsetLeft - strip.offsetLeft;
      var right = left + thumb.offsetWidth;
      var pad = 48;
      var target = null;
      if (left - pad < strip.scrollLeft) target = Math.max(0, left - pad);
      else if (right + pad > strip.scrollLeft + strip.clientWidth) target = right + pad - strip.clientWidth;
      if (target === null) return;
      if (typeof strip.scrollTo === 'function') strip.scrollTo({ left: target, behavior: reduceMotion ? 'auto' : 'smooth' });
      else strip.scrollLeft = target;
    }

    function slideCount() {
      return el.slides.filter(function (s) {
        return s.getAttribute('data-flavor') === state.flavor;
      }).length;
    }

    // Delivery cadence of the selected plan in days. 1 box every 30, 2 every 60, 3 every 90 unless the plan says otherwise.
    function days() {
      var d = cfg.cadenceDays && cfg.cadenceDays[String(state.subQty)];
      return String(d || state.subQty * 30);
    }

    // Cadence text of the selected tile, from its setting.
    function cadence() {
      return cfg.labels['tileCadence' + state.subQty] || ('every ' + days() + ' days');
    }

    function fillCadence(s) {
      return (s || '').replace('{days}', days()).replace('{cadence}', cadence());
    }

    function setState(patch) {
      var flavorChanged = patch.flavor !== undefined && patch.flavor !== state.flavor;
      Object.keys(patch).forEach(function (k) {
        state[k] = patch[k];
      });
      if (flavorChanged && el.thumbStrip) el.thumbStrip.scrollLeft = 0;
      // Rules. Strawberry Lemon is one-time only. Subscribe is Lemon only. A tile needs a plan.
      if (state.flavor === 'straw' && !cfg.flavors.straw) state.flavor = 'lemon';
      if (!hasSub || state.flavor === 'straw') state.mode = 'once';
      if (!cfg.plans[String(state.subQty)]) state.subQty = cfg.subDefault || Number(planKeys[0]) || 1;
      state.qty = Math.max(1, Math.min(3, state.qty));
      render();
    }

    function render() {
      var flavor = cfg.flavors[state.flavor];
      var isSub = state.mode === 'sub';
      var isStraw = state.flavor === 'straw';
      var p = isSub ? plan() : null;

      // Form. The one source of truth.
      if (el.inputId) el.inputId.value = flavor.variantId;
      if (el.inputQty) el.inputQty.value = isSub ? state.subQty : state.qty;
      if (el.inputPlan) {
        el.inputPlan.value = isSub ? p.id : '';
        el.inputPlan.disabled = !isSub;
      }

      // Radios
      qsa('input[name="gs-flavor"]', root).forEach(function (r) {
        r.checked = r.value === state.flavor;
      });
      qsa('input[name="gs-mode"]', root).forEach(function (r) {
        r.checked = r.value === state.mode;
      });
      qsa('input[name="gs-qty"]', root).forEach(function (r) {
        r.checked = Number(r.value) === state.qty;
      });
      qsa('input[name="gs-sub-qty"]', root).forEach(function (r) {
        r.checked = Number(r.value) === state.subQty;
      });

      // Cards. Strawberry shows the Limited Edition box where the subscribe card sits.
      if (el.subCard) {
        show(el.subCard, !isStraw);
        el.subCard.classList.toggle('is-selected', isSub);
        el.subCard.classList.toggle('is-dimmed', !isSub);
      }
      show(el.limited, isStraw);
      if (el.onceCard) {
        el.onceCard.classList.toggle('is-selected', !isSub);
        el.onceCard.classList.toggle('is-dimmed', isSub);
      }

      // Subscribe card follows the selected tile.
      if (hasSub) {
        var sp = plan();
        setText(el.subNow, money(sp.total));
        setText(el.subWas, money(sp.was));
        setText(el.subFlag, (cfg.labels.saveFlag || '').replace('{percent}', String(sp.save)));
        if (el.subGiftsLine && cfg.labels.subGiftsLine) {
          var giftsHtml = cfg.labels.subGiftsLine.replace('{percent}', String(sp.save));
          if (el.subGiftsLine.innerHTML !== giftsHtml) el.subGiftsLine.innerHTML = giftsHtml;
        }
        var tileLabel = (cfg.labels['tile' + state.subQty] || '').toLowerCase();
        setText(el.subQtyLabel, (cfg.labels.subQtyHeading || '').replace('{qty}', tileLabel).replace('{days}', days()));
        el.subTiles.forEach(function (t) {
          t.classList.toggle('is-selected', isSub && Number(t.getAttribute('data-gs-sub-tile')) === state.subQty);
        });
      }

      // One-time tiles follow the flavor's price.
      el.tiles.forEach(function (t) {
        var q = Number(t.getAttribute('data-gs-tile'));
        t.classList.toggle('is-selected', !isSub && q === state.qty);
        var price = oncePrice(state.flavor, q);
        setText(qs('[data-gs-tile-price]', t), money(price));
        var per = money2(Math.round(price / (cfg.servings * q))) + ' ' + cfg.labels.perServing;
        if (q > 1) per = money(Math.round(price / q)) + ' ' + cfg.labels.perBox + ' · ' + per;
        setText(qs('[data-gs-tile-per]', t), per);
      });

      // Flavor copy
      setText(el.flavorName, flavor.name);
      qsa('[data-gs-lemon-only]', root).forEach(function (n) {
        show(n, !isStraw);
      });
      qsa('[data-gs-straw-only]', root).forEach(function (n) {
        show(n, isStraw);
      });

      // Gallery. Desktop shows one slide. Mobile shows every slide of the flavor in a swipe track.
      var mobileGallery = isMobileGallery();
      el.slides.forEach(function (s) {
        var mine = s.getAttribute('data-flavor') === state.flavor;
        var on = mine && (mobileGallery || Number(s.getAttribute('data-index')) === state.slide);
        show(s, on);
      });
      el.thumbs.forEach(function (t) {
        var mine = t.getAttribute('data-flavor') === state.flavor;
        var active = mine && Number(t.getAttribute('data-index')) === state.slide;
        show(t, mine);
        t.classList.toggle('is-active', active);
        t.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      if (mobileGallery) {
        if (!slideFromSwipe) scrollStageTo(state.slide);
        var activeThumb = el.thumbs.filter(function (t) {
          return t.classList.contains('is-active');
        })[0];
        scrollThumbIntoView(activeThumb);
        var last = slideCount() - 1;
        if (el.prev) el.prev.disabled = state.slide <= 0;
        if (el.next) el.next.disabled = state.slide >= last;
      }
      slideFromSwipe = false;

      // Prices and labels
      var now = isSub ? p.total : oncePrice(state.flavor, state.qty);
      var was = isSub ? p.was : state.qty > 1 ? flavor.price * state.qty : 0;
      var available = flavor.available;
      var label = isSub ? cfg.labels.ctaSub : cfg.labels.ctaOnce;
      label = fillCadence(label.replace('{price}', money(now)));
      setText(el.oncePrice, money(oncePrice(state.flavor, state.qty)));
      if (!available) label = cfg.labels.soldOut;
      if (!cfg.useAppWidget || !available) setText(el.ctaLabel, label);
      if (el.button) el.button.disabled = !available;
      setText(el.delivery, isSub ? fillCadence(cfg.labels.deliverySub) : cfg.labels.deliveryOnce);

      // Panels under the button
      show(qs('[data-gs-panel="gifts"]', root), isSub);
      show(qs('[data-gs-panel="once"]', root), !isSub && !isStraw);
      show(qs('[data-gs-panel="straw"]', root), isStraw);

      // Sticky bar mirrors the form
      if (el.sticky) {
        var q = isSub ? state.subQty : state.qty;
        var noteKey = isSub ? (q > 1 ? 'stickySubMany' : 'stickySubOne') : q > 1 ? 'stickyOnceMany' : 'stickyOnceOne';
        var note = fillCadence((cfg.labels[noteKey] || '').replace('{qty}', String(q)));
        setText(qs('[data-gs-sticky-note]', el.sticky), flavor.name + ' · ' + note);
        if (cfg.useAppWidget) {
          setText(qs('[data-gs-sticky-note]', el.sticky), flavor.name);
          setText(qs('[data-gs-sticky-now]', el.sticky), '');
          setText(qs('[data-gs-sticky-was]', el.sticky), '');
        } else {
          setText(qs('[data-gs-sticky-now]', el.sticky), money(now));
          setText(qs('[data-gs-sticky-was]', el.sticky), was ? money(was) : '');
        }
        var short = !available ? cfg.labels.soldOut : isSub ? cfg.labels.ctaSubShort : cfg.labels.ctaOnceShort;
        setText(qs('[data-gs-sticky-label]', el.sticky), short);
        var sb = qs('[data-gs-sticky-button]', el.sticky);
        if (sb) sb.disabled = !available;

        var thumbImg = qs('.gs-sticky__thumb img', el.sticky);
        var firstThumb = qs('[data-gs-thumb][data-flavor="' + state.flavor + '"][data-index="0"] img', root);
        if (thumbImg && firstThumb && !thumbImg.hasAttribute('srcset')) {
          var src = firstThumb.currentSrc || firstThumb.src;
          if (src && thumbImg.src !== src) thumbImg.src = src;
        }
      }

      root.setAttribute('data-gs-flavor', state.flavor);
      root.setAttribute('data-gs-mode', state.mode);
      document.dispatchEvent(
        new CustomEvent('gs:pdp-change', { detail: { flavor: state.flavor, mode: state.mode, qty: isSub ? state.subQty : state.qty } })
      );
    }

    // Events
    root.addEventListener('change', function (e) {
      var t = e.target;
      if (!t || t.type !== 'radio') return;
      if (t.name === 'gs-flavor') {
        if (t.value === 'straw') setState({ flavor: 'straw', mode: 'once', slide: 0 });
        else setState({ flavor: 'lemon', mode: hasSub ? 'sub' : 'once', slide: 0 });
      } else if (t.name === 'gs-mode') {
        if (t.value === 'sub') setState(state.flavor === 'straw' ? { mode: 'sub', flavor: 'lemon', slide: 0 } : { mode: 'sub' });
        else setState({ mode: 'once' });
      } else if (t.name === 'gs-qty') {
        setState({ mode: 'once', qty: Number(t.value) || 1 });
      } else if (t.name === 'gs-sub-qty') {
        setState({ mode: 'sub', subQty: Number(t.value) || 1 });
      }
    });

    // Click anywhere on a card selects it.
    [el.subCard, el.onceCard].forEach(function (card) {
      if (!card) return;
      card.addEventListener('click', function (e) {
        if (e.target.closest('label, input, button, a')) return;
        var radio = qs('input[name="gs-mode"]', card);
        if (radio && !radio.checked) {
          radio.checked = true;
          radio.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    });

    el.thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        setState({ slide: Number(t.getAttribute('data-index')) || 0 });
      });
    });

    // Arrows step one image and clamp at the ends.
    if (el.prev) {
      el.prev.addEventListener('click', function () {
        setState({ slide: Math.max(0, state.slide - 1) });
      });
    }
    if (el.next) {
      el.next.addEventListener('click', function () {
        setState({ slide: Math.min(slideCount() - 1, state.slide + 1) });
      });
    }

    // A swipe on the mobile stage updates the slide in state. Scroll events right after a programmatic
    // scroll are ignored so the two never chase each other.
    if (el.stage) {
      var scrollTick = false;
      el.stage.addEventListener(
        'scroll',
        function () {
          if (!isMobileGallery() || Date.now() < ignoreScrollUntil || scrollTick) return;
          scrollTick = true;
          window.requestAnimationFrame(function () {
            scrollTick = false;
            var w = el.stage.clientWidth || 1;
            var n = Math.round(el.stage.scrollLeft / w);
            if (n !== state.slide) {
              slideFromSwipe = true;
              setState({ slide: n });
            }
          });
        },
        { passive: true }
      );
      if (mobileMq) {
        var onMq = function () {
          render();
          if (isMobileGallery()) {
            ignoreScrollUntil = Date.now() + 400;
            el.stage.scrollLeft = state.slide * el.stage.clientWidth;
          }
        };
        if (mobileMq.addEventListener) mobileMq.addEventListener('change', onMq);
        else if (mobileMq.addListener) mobileMq.addListener(onMq);
      }
    }

    var factsBtn = qs('[data-gs-facts]', root);
    if (factsBtn) {
      factsBtn.addEventListener('click', function () {
        var target = el.slides.filter(function (s) {
          return s.hasAttribute('data-facts') && s.getAttribute('data-flavor') === state.flavor;
        })[0];
        if (!target) return;
        setState({ slide: Number(target.getAttribute('data-index')) || 0 });
        var stage = qs('.gs-gallery__stage', root);
        if (stage && stage.getBoundingClientRect().top < 0) {
          stage.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
        }
      });
    }

    var switchBtn = qs('[data-gs-switch-sub]', root);
    if (switchBtn) {
      switchBtn.addEventListener('click', function () {
        setState({ mode: 'sub', flavor: 'lemon', slide: 0 });
      });
    }

    var grabBtn = qs('[data-gs-grab-3]', root);
    if (grabBtn) {
      grabBtn.addEventListener('click', function () {
        setState({ mode: 'once', qty: 3 });
      });
    }

    // Add to cart. One request with every line. Subscription adds the drink plus both gift lines.
    // One-time and Strawberry Lemon add the drink line only.
    function setBusy(on) {
      qsa('[data-gs-buy-button], [data-gs-sticky-button]').forEach(function (b) {
        b.classList.toggle('is-busy', on);
        b.setAttribute('aria-busy', on ? 'true' : 'false');
      });
    }

    function showError(msg) {
      if (!el.error) return;
      setText(el.error, msg || '');
      show(el.error, !!msg);
    }

    form.addEventListener('submit', function (e) {
      if (cfg.useAppWidget) return;
      e.preventDefault();
      var flavor = cfg.flavors[state.flavor];
      var isSub = state.mode === 'sub';
      var items = [{ id: flavor.variantId, quantity: isSub ? state.subQty : state.qty }];
      if (isSub) {
        items[0].selling_plan = plan().id;
        if (state.flavor === 'lemon') {
          (cfg.giftIds || []).forEach(function (id) {
            items.push({ id: id, quantity: 1 });
          });
        }
      }
      showError('');
      setBusy(true);
      Cart.add(items)
        .then(function () {
          Cart.open();
        })
        .catch(function (err) {
          showError((err && (err.description || err.message)) || cfg.labels.addError);
        })
        .then(function () {
          setBusy(false);
        });
    });

    render();
    initSticky(el.sticky, el.button);
  }

  /* ---------- Sticky add to cart ---------- */
  function initSticky(bar, mainButton) {
    if (!bar || !mainButton || !('IntersectionObserver' in window)) return;

    var pastButton = false;
    var footerInView = false;
    document.body.classList.add('gs-has-sticky');

    function apply() {
      var on = pastButton && !footerInView;
      bar.classList.toggle('is-visible', on);
      if (on) bar.removeAttribute('inert');
      else bar.setAttribute('inert', '');
    }

    // Two observers so a jump from below the button to above it is still caught.
    // inView: the button is on screen. reached: the button is on screen or above it.
    var inView = true;
    var reached = false;

    new IntersectionObserver(function (entries) {
      inView = entries[entries.length - 1].isIntersecting;
      pastButton = reached && !inView;
      apply();
    }).observe(mainButton);

    new IntersectionObserver(
      function (entries) {
        reached = entries[entries.length - 1].isIntersecting;
        pastButton = reached && !inView;
        apply();
      },
      { rootMargin: '1000000px 0px 0px 0px' }
    ).observe(mainButton);

    // Hidden again when the footer is in view.
    var footer = qs('[data-gs-footer]');
    if (footer) {
      new IntersectionObserver(function (entries) {
        footerInView = entries[entries.length - 1].isIntersecting;
        apply();
      }).observe(footer);
    }
  }

  /* ---------- 3D stick pack flip ---------- */
  function initPack() {
    var stage = qs('[data-gs-pack-stage]');
    var pack = qs('[data-gs-pack]');
    if (!stage || !pack) return;
    var shadow = qs('[data-gs-pack-shadow]', stage);

    // On the PDP the pack art follows the selected flavor.
    document.addEventListener('gs:pdp-change', function (e) {
      var flavor = e.detail && e.detail.flavor === 'straw' ? 'straw' : 'lemon';
      qsa('[data-gs-pack-skin]', pack).forEach(function (skin) {
        show(skin, skin.getAttribute('data-gs-pack-skin') === flavor);
      });
    });

    function spinTo(deg) {
      var c = Math.abs(Math.cos((deg * Math.PI) / 180));
      pack.style.transform =
        'rotateZ(5deg) rotateX(' + (7 * (1 - c)).toFixed(1) + 'deg) rotateY(' + deg.toFixed(1) + 'deg)';
      pack.style.setProperty('--gs-sheen', (110 - ((Math.abs(deg) % 180) / 180) * 120).toFixed(0) + '%');
      if (shadow) shadow.style.setProperty('--gs-sh', (0.25 + 0.75 * c).toFixed(2));
    }

    if (reduceMotion) {
      spinTo(0);
      return;
    }

    var ticking = false;
    function update() {
      ticking = false;
      var r = stage.getBoundingClientRect();
      var vh = window.innerHeight || 1;
      // d is 0 when the stage is centered. Positive while it is still below center.
      var d = (r.top + r.height / 2 - vh / 2) / vh;
      var enter = 0.5 + r.height / (2 * vh);
      if (d >= 0) {
        // Starts on its back as it enters. Faces front exactly at center.
        var t = Math.max(0, Math.min(1, 1 - d / enter));
        t = t * t * (3 - 2 * t);
        spinTo(180 * (1 - t));
      } else {
        // Drifts to about -24deg as it leaves.
        spinTo(-24 * Math.min(1, -d / enter));
      }
    }
    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    update();
  }

  /* ---------- Supplement facts links outside the buy box ---------- */
  function initFactsLinks() {
    qsa('[data-gs-facts-link]').forEach(function (link) {
      link.addEventListener('click', function (e) {
        var btn = qs('[data-gs-facts]');
        if (!btn) return;
        e.preventDefault();
        btn.click();
        var stage = qs('.gs-gallery__stage');
        if (stage) stage.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
      });
    });
  }

  /* ---------- 90-day arc chart ---------- */
  function initArc() {
    qsa('[data-gs-arc]').forEach(function (root) {
      var chart = qs('[data-gs-arc-chart]', root);
      var tabs = qsa('[data-gs-arc-tab]', root);
      var panels = qsa('[data-gs-arc-panel]', root);
      var markers = qsa('[data-gs-arc-marker]', root);
      var scan = qs('[data-gs-arc-scan]', root);

      // Line draws on once, when 30% of the chart is in view.
      if (chart && !reduceMotion && 'IntersectionObserver' in window) {
        root.classList.add('gs-arc--armed');
        var io = new IntersectionObserver(
          function (entries) {
            if (
              entries.some(function (e) {
                return e.isIntersecting;
              })
            ) {
              root.classList.add('is-drawn');
              io.disconnect();
            }
          },
          { threshold: 0.3 }
        );
        io.observe(chart);
      }

      function select(i, focus) {
        tabs.forEach(function (t, k) {
          var on = k === i;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          if (on) t.removeAttribute('tabindex');
          else t.setAttribute('tabindex', '-1');
          if (on && focus) t.focus();
        });
        panels.forEach(function (p, k) {
          show(p, k === i);
        });
        markers.forEach(function (m, k) {
          var on = k === i;
          var halo = qs('.gs-arc__halo', m);
          var dot = qs('.gs-arc__dot', m);
          if (halo) halo.setAttribute('r', on ? 19 : 13);
          if (dot) dot.setAttribute('r', on ? 10 : 6);
          if (on && scan) {
            scan.setAttribute('x1', m.getAttribute('data-x'));
            scan.setAttribute('x2', m.getAttribute('data-x'));
          }
        });
      }

      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () {
          select(i, false);
        });
        t.addEventListener('keydown', function (e) {
          var n = tabs.length;
          if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
            e.preventDefault();
            select((i + 1) % n, true);
          } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
            e.preventDefault();
            select((i + n - 1) % n, true);
          } else if (e.key === 'Home') {
            e.preventDefault();
            select(0, true);
          } else if (e.key === 'End') {
            e.preventDefault();
            select(n - 1, true);
          }
        });
      });
    });
  }

  /* ---------- Customer reels. Tap to play in place. Muted by default, tap to unmute. ---------- */
  function initReels() {
    var reels = qsa('[data-gs-reel]');

    function stopOthers(except) {
      reels.forEach(function (r) {
        if (r !== except && r.__video && !r.__video.paused) r.__video.pause();
      });
    }

    reels.forEach(function (reel) {
      var src = reel.getAttribute('data-gs-reel-src');
      var playBtn = qs('[data-gs-reel-play]', reel);
      var muteBtn = qs('[data-gs-reel-mute]', reel);
      if (!src || !playBtn) return;

      function setMuteUi(video) {
        if (!muteBtn) return;
        muteBtn.setAttribute('aria-pressed', video.muted ? 'true' : 'false');
        muteBtn.setAttribute('aria-label', muteBtn.getAttribute(video.muted ? 'data-label-muted' : 'data-label-sound') || '');
        muteBtn.classList.toggle('is-sound', !video.muted);
      }

      // The video element exists only after the first tap, so the mp4 is never requested before then.
      function video() {
        if (reel.__video) return reel.__video;
        var v = document.createElement('video');
        v.className = 'gs-reel__video';
        v.muted = true;
        v.setAttribute('muted', '');
        v.setAttribute('playsinline', '');
        v.setAttribute('preload', 'none');
        v.src = src;
        v.addEventListener('play', function () {
          reel.classList.add('is-playing');
          playBtn.setAttribute('aria-pressed', 'true');
          show(muteBtn, true);
        });
        v.addEventListener('pause', function () {
          reel.classList.remove('is-playing');
          playBtn.setAttribute('aria-pressed', 'false');
          show(muteBtn, false);
        });
        v.addEventListener('ended', function () {
          v.currentTime = 0;
          reel.classList.remove('is-playing');
          playBtn.setAttribute('aria-pressed', 'false');
          show(muteBtn, false);
        });
        reel.insertBefore(v, reel.firstChild);
        reel.__video = v;
        setMuteUi(v);
        return v;
      }

      playBtn.addEventListener('click', function () {
        var v = video();
        if (v.paused) {
          stopOthers(reel);
          var p = v.play();
          if (p && p.catch) p.catch(function () {});
        } else {
          v.pause();
        }
      });

      if (muteBtn) {
        muteBtn.addEventListener('click', function () {
          var v = video();
          v.muted = !v.muted;
          setMuteUi(v);
        });
      }
    });

    // Page-level flavor swap. Lemon-only nodes (lemon reviews, the subscribe offer, the gold pack art in the
    // compare chart) hide when Strawberry Lemon is selected, and straw-only nodes take their place.
    document.addEventListener('gs:pdp-change', function (e) {
      var straw = e.detail && e.detail.flavor === 'straw';
      qsa('[data-gs-lemon-only-global]').forEach(function (n) {
        show(n, !straw);
      });
      qsa('[data-gs-straw-only-global]').forEach(function (n) {
        show(n, straw);
      });
    });
  }

  /* ---------- Hero slider and rotating headline ---------- */
  function initHero() {
    qsa('[data-gs-hero]').forEach(function (root) {
      var slides = qsa('[data-gs-hero-slide]', root);
      var wordEls = qsa('[data-gs-hero-word]', root);
      var words = (root.getAttribute('data-words') || '').split('|').filter(Boolean);
      var lock = root.getAttribute('data-lock') || 'rotate';
      var interval = Number(root.getAttribute('data-interval')) || 6600;
      var current = 0;
      var auto = true;
      var paused = false;

      function go(i, moveFocus) {
        if (i === current || !slides[i]) return;
        current = i;
        slides.forEach(function (s, k) {
          var on = k === i;
          s.classList.toggle('is-active', on);
          if (on) s.removeAttribute('inert');
          else s.setAttribute('inert', '');
        });
        if (moveFocus) {
          var btn = qs('[data-gs-hero-go="' + i + '"]', slides[i]);
          if (btn) btn.focus();
        }
      }

      // Any click on the controls stops auto-advance for good.
      root.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-gs-hero-go]');
        if (!btn) return;
        auto = false;
        go(Number(btn.getAttribute('data-gs-hero-go')), true);
      });

      root.addEventListener('mouseenter', function () {
        paused = true;
      });
      root.addEventListener('mouseleave', function () {
        paused = false;
      });
      root.addEventListener('focusin', function () {
        paused = true;
      });
      root.addEventListener('focusout', function () {
        paused = false;
      });

      if (reduceMotion) return;

      // Rotating word. About every 2.2s with a short fade.
      if (lock === 'rotate' && words.length > 1 && wordEls.length) {
        var w = 0;
        window.setInterval(function () {
          if (document.hidden) return;
          w = (w + 1) % words.length;
          wordEls.forEach(function (n) {
            n.classList.add('is-out');
          });
          window.setTimeout(function () {
            wordEls.forEach(function (n) {
              n.textContent = words[w];
              n.classList.remove('is-out');
            });
          }, 250);
        }, 2200);
      }

      if (slides.length > 1) {
        window.setInterval(function () {
          if (!auto || paused || document.hidden) return;
          go((current + 1) % slides.length, false);
        }, interval);
      }
    });
  }

  /* ---------- Routes animation ---------- */
  function initRoutes() {
    qsa('[data-gs-routes]').forEach(function (root) {
      var btn = qs('[data-gs-routes-run]', root);
      var label = qs('[data-gs-routes-run-label]', root);
      var nodes = qsa('[data-gs-node]', root);
      var sugar = qs('[data-gs-lane="sugar"]', root);
      var sugarEnd = sugar ? qs('.gs-node--end', sugar) : null;
      var msgs = qsa('[data-gs-routes-msg]', root);
      var timer = null;
      var t = 0;

      function render() {
        nodes.forEach(function (n) {
          n.classList.toggle('is-lit', t >= Number(n.getAttribute('data-at')));
        });
        if (sugar) sugar.classList.toggle('is-crashed', t >= 9);
        if (sugarEnd) {
          sugarEnd.classList.toggle('is-spike', t >= 7 && t < 9);
          sugarEnd.classList.toggle('is-spent', t >= 9);
        }
        var stage = t === 0 ? 0 : t < 4 ? 1 : t < 7 ? 2 : t < 9 ? 3 : 4;
        msgs.forEach(function (m) {
          show(m, Number(m.getAttribute('data-gs-routes-msg')) === stage);
        });
        if (btn && label) {
          var key = t === 0 ? 'data-label-idle' : t >= 10 ? 'data-label-again' : 'data-label-running';
          setText(label, btn.getAttribute(key) || '');
        }
      }

      // A run counter ticks 0 to 10 every 560ms and lights the nodes.
      function run() {
        if (timer) window.clearInterval(timer);
        if (reduceMotion) {
          t = 10;
          render();
          return;
        }
        t = 1;
        render();
        timer = window.setInterval(function () {
          t += 1;
          render();
          if (t >= 10) window.clearInterval(timer);
        }, 560);
      }

      if (btn) btn.addEventListener('click', run);

      // Runs once on its own when the section scrolls into view.
      if (!reduceMotion && 'IntersectionObserver' in window) {
        var io = new IntersectionObserver(
          function (entries) {
            if (
              entries.some(function (e) {
                return e.isIntersecting;
              })
            ) {
              io.disconnect();
              if (t === 0) run();
            }
          },
          { threshold: 0.4 }
        );
        io.observe(qs('.gs-routes__panel', root) || root);
      }
    });
  }

  /* ---------- Phone menu. Burger toggles the panel; link tap, Escape, outside tap and a resize past 750px close it. ---------- */
  function initMenu() {
    var btn = qs('[data-gs-menu-toggle]');
    var menu = qs('[data-gs-menu]');
    if (!btn || !menu) return;
    function set(open) {
      menu.hidden = !open;
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
    btn.addEventListener('click', function () {
      set(menu.hidden);
    });
    menu.addEventListener('click', function (e) {
      if (e.target.closest('a')) set(false);
    });
    document.addEventListener('click', function (e) {
      if (menu.hidden) return;
      if (e.target.closest('[data-gs-menu]') || e.target.closest('[data-gs-menu-toggle]')) return;
      set(false);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !menu.hidden) {
        set(false);
        btn.focus();
      }
    });
    var wide = window.matchMedia('(min-width: 750px)');
    var onWide = function (ev) {
      if (ev.matches) set(false);
    };
    if (wide.addEventListener) wide.addEventListener('change', onWide);
    else if (wide.addListener) wide.addListener(onWide);
  }

  /* ---------- Sticky header ---------- */
  function initStickyHeader() {
    var header = qs('.gs-header');
    if (!header) return;
    var ticking = false;
    function update() {
      ticking = false;
      header.classList.toggle('is-stuck', (window.scrollY || 0) >= 8);
    }
    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    update();
  }

  /* ---------- Beakers animation ---------- */
  function initBeakers() {
    qsa('[data-gs-beakers]').forEach(function (root) {
      var btn = qs('[data-gs-beakers-run]', root);
      var label = qs('[data-gs-beakers-run-label]', root);
      var beakers = qsa('[data-gs-beaker]', root).map(function (el) {
        return {
          kind: el.getAttribute('data-gs-beaker'),
          liquid: qs('[data-gs-beaker-liquid]', el),
          chips: qsa('[data-gs-beaker-chip]', el),
        };
      });
      var timer = null;
      var t = 0;

      // Godspeed fills from tick 1. Butanediol waits three ticks for the liver, then fills slower.
      // Both end at the same height on purpose.
      function fillFor(kind, tick) {
        if (kind === 'gs') return Math.min(86, tick * 22);
        return tick < 3 ? 0 : Math.min(86, (tick - 3) * 13);
      }
      var litAt = { gs: [1, 2, 3], bd: [1, 2, 5, 8] };

      function render() {
        beakers.forEach(function (b) {
          if (b.liquid) b.liquid.style.height = fillFor(b.kind, t) + '%';
          var at = litAt[b.kind] || [];
          b.chips.forEach(function (chip, i) {
            chip.classList.toggle('is-lit', t >= (at[i] === undefined ? 99 : at[i]));
            // The liver chip runs hot while it works.
            chip.classList.toggle('is-hot', b.kind === 'bd' && i === 1 && t >= 2 && t <= 4);
          });
        });
        if (btn && label) {
          var key = t === 0 ? 'data-label-idle' : t >= 10 ? 'data-label-again' : 'data-label-running';
          setText(label, btn.getAttribute(key) || '');
        }
      }

      function run() {
        if (timer) window.clearInterval(timer);
        if (reduceMotion) {
          t = 10;
          render();
          return;
        }
        t = 1;
        render();
        timer = window.setInterval(function () {
          t += 1;
          render();
          if (t >= 10) window.clearInterval(timer);
        }, 560);
      }

      if (btn) btn.addEventListener('click', run);
      render();

      // Runs once on its own when the section scrolls into view.
      if (!reduceMotion && 'IntersectionObserver' in window) {
        var io = new IntersectionObserver(
          function (entries) {
            if (
              entries.some(function (e) {
                return e.isIntersecting;
              })
            ) {
              io.disconnect();
              if (t === 0) run();
            }
          },
          { threshold: 0.4 }
        );
        io.observe(qs('.gs-beakers__panel', root) || root);
      } else if (reduceMotion) {
        t = 10;
        render();
      }
    });
  }

  /* ---------- Headline band. Rotating word, no slider. ---------- */
  function initHeadline() {
    qsa('[data-gs-headline]').forEach(function (root) {
      var wordEls = qsa('[data-gs-headline-word]', root);
      var words = (root.getAttribute('data-words') || '').split('|').filter(Boolean);
      var lock = root.getAttribute('data-lock') || 'rotate';
      if (lock !== 'rotate') {
        var idx = Math.max(0, Math.min(words.length - 1, Number(lock) - 1));
        wordEls.forEach(function (n) {
          n.textContent = words[idx] || n.textContent;
        });
        return;
      }
      if (reduceMotion || words.length < 2 || !wordEls.length) return;
      var w = 0;
      window.setInterval(function () {
        if (document.hidden) return;
        w = (w + 1) % words.length;
        wordEls.forEach(function (n) {
          n.classList.add('is-out');
        });
        window.setTimeout(function () {
          wordEls.forEach(function (n) {
            n.textContent = words[w];
            n.classList.remove('is-out');
          });
        }, 250);
      }, 2200);
    });
  }

  /* ---------- Compare table. Mobile picks one competitor column. ---------- */
  function initCompare() {
    qsa('[data-gs-cmp]').forEach(function (root) {
      var chips = qsa('[data-gs-cmp-chip]', root);
      if (!chips.length) return;
      function pick(col) {
        chips.forEach(function (c) {
          var on = c.getAttribute('data-gs-cmp-chip') === col;
          c.classList.toggle('is-active', on);
          c.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        qsa('[data-gs-cmp-col]', root).forEach(function (cell) {
          if (cell.getAttribute('data-gs-cmp-col') === col) cell.setAttribute('data-active', '');
          else cell.removeAttribute('data-active');
        });
      }
      chips.forEach(function (c) {
        c.addEventListener('click', function () {
          pick(c.getAttribute('data-gs-cmp-chip'));
        });
      });
    });
  }

  function init() {
    initStickyHeader();
    initMenu();
    initCompare();
    initHeadline();
    initBeakers();
    Cart.bind();
    initRoutes();
    initHero();
    initReels();
    initPack();
    initArc();
    initPdp();
    initFactsLinks();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
